/**
 * Glasronde 0.9.189, vondst 4 (Frank 22 oktober 2026): de omschrijvingen en labels van
 * de meegeleverde skills bleven in het Nederlands Engels. Ze komen van de server uit
 * `backend/galaxy/*.md`, en die bestanden zijn Engels. Hier staat per skill (op slug)
 * de Nederlandse tekst; in `taal-en.js` staat daar het Engels van het bestand bij.
 *
 * ALLEEN ONGEWIJZIGDE TEKST WORDT VERTAALD. Is de omschrijving niet meer letterlijk die
 * uit het bestand, dan heeft iemand haar zelf aangepast, en dan blijft zij staan zoals
 * zij is. `galaxytekst.test.js` eist dat elke skill in `backend/galaxy` hier staat en
 * dat het Engels letterlijk gelijk is aan het bestand.
 *
 * PUUR.
 */
import { EN_VAN_NL } from "./taal-en";

export const GALAXY_NL = {
  "brand-guardian": "Houdt alles wat je maakt in lijn met de stem, de termen en de stijlregels van je merk.",
  "code-mentor": "Beoordeelt, legt uit en verbetert code met de grondigheid van een ervaren ontwikkelaar.",
  "compliance-auditor": "Checklists om klaar te zijn voor eIDAS 2.0, NIS2 en de AI Act, gericht op kleinere bedrijven.",
  "gdpr-officer": "Stelt inzageverzoeken op, brengt je digitale voetafdruk in kaart en schrijft de berichten bij een datalek.",
  "inbox-sovereign": "Lokaal je mail sorteren, samenvatten en antwoorden opstellen over je geïmporteerde mailarchief. Je mail komt nooit bij een derde.",
  "market-research": "Onderzoekt concurrenten, markten en actuele webgegevens, gestructureerd en met bronnen.",
  "growth-engine": "Analyseert de marktdynamiek en maakt er concrete groeistrategieën voor een bedrijf van.",
  "creative-studio": "Maakt beeldconcepten, merkmateriaal en teksten, nauwkeurig en in lijn met je merk.",
  "vault-analyst": "Beoordeelt contracten en documenten in je eigen documentopslag. Wat vertrouwelijk is, blijft op je apparaat.",
  "meeting-notes": "Maakt van ruwe vergaderverslagen of losse aantekeningen een gestructureerd verslag met eigenaren en deadlines.",
  "knowledge-archivist": "Begeleidt je bij het importeren van archieven, notities en documenten in je eigen kennisbank, zodat zoeken vanaf dag een werkt.",
};

/** De categorieën uit de bestanden, plus de standaard van een nieuwe skill. */
export const CATEGORIE_NL = {
  creative: "creatief", engineering: "techniek", compliance: "naleving", sovereignty: "soevereiniteit",
  research: "onderzoek", growth: "groei", productivity: "productiviteit", general: "algemeen",
};

/** De omschrijving in de taal van de app, of ongewijzigd als iemand haar heeft aangepast. */
export function omschrijving(skill, t) {
  const nl = GALAXY_NL[skill?.slug];
  return nl && EN_VAN_NL[nl] === skill.description ? t(nl) : skill?.description;
}

/** Een categorie in de taal van de app; een eigen categorie blijft zoals zij is. */
export function categorie(waarde, t) {
  const nl = CATEGORIE_NL[waarde];
  return nl ? t(nl) : waarde;
}
